import { useMemo } from 'react';
import PolicyLoader from './PolicyLoader';
import { CoreApi } from '../../services';

export const usePolicyLoader = () => {
  const api = useMemo(() => new CoreApi(), []);
  return useMemo(() => new PolicyLoader(api), [api]);
};
